import { Reorder } from "framer-motion";
import { Item } from "./Item";

import React, { useEffect, useState } from 'react'
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import { v4 as UUID } from "uuid"
function EditForm({ serverURL, user, setFormSectionVisibility, oldData, setEditFormView, getAllForms }) {

    const [formId, setformId] = useState(oldData.name)
    const [formViewData, setFormViewData] = useState({ "form": [], "buttons": [] })

    const [newForm, setNewForm] = useState(false);

    const [showToast, setShowToast] = useState(false)
    const [toastTitle, setToastTitle] = useState("")
    const [toastType, setToastType] = useState("")
    const [toastMessage, setToastMessage] = useState("")

    const initialItems = oldData.fields.form.map((field, key) => {
        return field.type.id.split("_type_selector")[0]
    }).concat(oldData.fields.buttons.map((field, key) => {
        return field.type.id.split("_type_selector")[0]
    }));

    const [items, setItems] = useState(initialItems);

    const removeTheOneField = (id) => {
        const restAll = items.filter((item) => { return item !== id });
        setItems(restAll)
    }

    const getAllData = () => {
        const data1 = document.querySelectorAll(".dataFieldLabel");
        const data2 = document.querySelectorAll(".dataFieldType");
        const data3 = document.querySelectorAll(".dataFieldOption");
        const data4 = document.querySelectorAll(".dataFieldRequirement");
        const data5 = document.querySelectorAll(".dataFieldDistinct");

        let data1Holder = [];
        let data2Holder = [];
        let data3Holder = [];
        let data4Holder = [];
        let data5Holder = [];

        for (let i = 0; i < data1.length; i++) {
            data1Holder.push({ "id": data1[i].id, "value": data1[i].value.trim() })
            data2Holder.push({ "id": data2[i].id, "value": data2[i].childNodes[2].childNodes[0].childNodes[0].innerHTML })
            data4Holder.push({ "id": data4[i].childNodes[0].id, "value": data4[i].childNodes[0].value })
            data5Holder.push({ "id": data5[i].childNodes[0].id, "value": data5[i].childNodes[0].value })
        }

        for (let i = 0; i < data3.length; i++) {
            data3Holder.push({ "id": data3[i].id, "value": data3[i].value.trim() })
        }

        // console.log(data1Holder,data3Holder)

        let dataFormat = [];
        let buttonsOnly = [];

        for (let i = 0; i < data1.length; i++) {
            const idToFilter = data1[i].id.split("_")[0]

            const typeFilter = data2Holder.filter((data) => { return data.id.includes(idToFilter) })[0].value;

            if (typeFilter !== "Submit" && typeFilter !== "Reset") {
                dataFormat.push({
                    "label": data1Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "type": data2Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "options": data3Holder.filter((data) => { return data.id.includes(idToFilter) }),
                    "isRequired": data4Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "isDistinct": data5Holder.filter((data) => { return data.id.includes(idToFilter) })[0]
                })
            } else {
                buttonsOnly.push({
                    "label": data1Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "type": data2Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "options": data3Holder.filter((data) => { return data.id.includes(idToFilter) }),
                    "isRequired": data4Holder.filter((data) => { return data.id.includes(idToFilter) })[0],
                    "isDistinct": data5Holder.filter((data) => { return data.id.includes(idToFilter) })[0]
                })
            }
        }

        console.log({ "form": dataFormat, "buttons": buttonsOnly })
        setFormViewData({ "form": dataFormat, "buttons": buttonsOnly })
    }


    const saveFormToDB = async (btn) => {
        const button = btn.target
        button.innerHTML = `<div class="spinner-border-sm spinner-border text-dark" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>`;
        button.disabled = true

        const query = {
            "formRefID": oldData._id,
            "userId": user.email,
            "userRef": user._id,
            "name": formId,
            "fields": formViewData
        }
        const saveFor = await axios.post(serverURL + "/forms/update", query);
        if (saveFor.status === 200) {
            console.log(saveFor.data)

            button.innerHTML = `Update`;
            button.disabled = true

            setShowToast(true)
            setToastTitle("Success")
            setToastType("success")
            setToastMessage("Form saved successfully.")

            setTimeout(() => {
                setNewForm(false)
                setFormSectionVisibility("forms")
                setEditFormView(false)
                getAllForms()
            }, 1000)
        } else {
            console.log(saveFor.data)
            button.innerHTML = `Update`;
            button.disabled = false
            setShowToast(true)
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(saveFor.data)
        }
    }

    useEffect(() => {
        // console.log(oldData)
    }, [])

    return (
        <>
            <form onSubmit={(e) => { e.preventDefault(); setItems([...items, UUID()]) }} className='p-4 rounded d-flex flex-column align-items-start shadow w-100' style={{ maxWidth: "700px" }}>
                <div className='w-100 mb-3'>
                    <button type="button" className='btn btn-sm btn-light rounded-pill fw-bold justify-self-center w-100 text-nowrap rounded-circle' style={{ maxWidth: "40px", height: "30px", width: "40px" }} onClick={(e) => { setNewForm(true); getAllData() }}>
                        <i className='fa fa-eye'></i>
                    </button>
                </div>
                <div className='w-100 mb-3'>
                    <input type="text" defaultValue={oldData.name} required onInput={(e) => { setformId(e.target.value) }} placeholder='Form Title' className='form-control w-100 fs-2' />
                </div>
                <Reorder.Group axis="y" onReorder={setItems} values={items} className='reorderThings'>
                    {items.map((item) => (
                        <Item
                            key={item}
                            item={item}
                            oldData={oldData}
                            removeTheOneField={removeTheOneField}
                        />
                    ))}
                </Reorder.Group>
                <div className='d-flex gap-2 justify-content-center align-items-center w-100'>
                    <button type="submit" className='btn btn-sm btn-warning  px-3 py-2 rounded-pill fw-bold justify-self-center w-100 text-nowrap overflow-hidden' style={{ maxWidth: "200px" }}>Add Field</button>
                    {/* <button type="button" className='btn btn-sm btn-info  px-3 py-2 rounded-pill fw-bold justify-self-center w-100 text-nowrap' style={{ maxWidth: "200px" }} onClick={(e) => { }}>Save Form</button> */}
                </div>
            </form>
            <Modal
                show={newForm}
                size='md'
                backdrop="static"
                onHide={() => {
                    setNewForm(false);
                    setShowToast(false);
                    setToastTitle("");
                    setToastType("");
                    setToastMessage("");
                }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            {formId}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='bg-secondary'>

                    <form onSubmit={(e) => { e.preventDefault() }} className='p-3 shadow-sm border rounded bg-light d-flex flex-column gap-2'>
                        {
                            formViewData.form.map((data, key) => {
                                return (
                                    <div key={key} className='p-0'>
                                        <label htmlFor={`${data.type.value === "Select" ? data.label.id : data.options[0].id}_view`} className='w-100'>
                                            {
                                                data.type.value !== "Reset" && data.type.value !== "Submit" ?
                                                    data.label.value
                                                    :
                                                    ""
                                            }
                                            {/* {JSON.stringify(data.type)} */}
                                            {
                                                data.type.value === "Text" ?
                                                    <input type='text' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                    :
                                                    data.type.value === "Phone" ?
                                                        <input type='tel' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                        :
                                                        data.type.value === "Number" ?
                                                            <input type='number' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                            :
                                                            data.type.value === "Email" ?
                                                                <input type='email' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                :
                                                                data.type.value === "Select" ?
                                                                    <select id={`${data.label.id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control'>
                                                                        {
                                                                            data.options.map((option, key) => {
                                                                                return (
                                                                                    <option key={key} value={option.value} id={`${option.id}_view`}>{option.value}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    :
                                                                    data.type.value === "Date" ?
                                                                        <input type='date' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                        :
                                                                        data.type.value === "Textarea" ?
                                                                            <textarea id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                            :
                                                                            data.type.value === "File" ?
                                                                                <input type='file' id={`${data.options[0].id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                                :
                                                                                data.type.value === "Reset" ?
                                                                                    <button type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                    :
                                                                                    data.type.value === "Submit" ?
                                                                                        <button type="button" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                        :
                                                                                        "Undefined Type"
                                            }
                                        </label>
                                    </div>
                                )
                            })
                        }
                        {
                            formViewData.buttons.length > 0 ?
                                <div className='p-2 d-flex gap-2 justify-content-center'>
                                    {
                                        formViewData.buttons.map((data, key) => {
                                            return (
                                                data.type.value === "Reset" ?
                                                    <button key={key} type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value ? data.label.value : "Reset"}</button>
                                                    :
                                                    data.type.value === "Submit" ?
                                                        <button key={key} type="submit" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value ? data.label.value : "Submit"}</button>
                                                        :
                                                        "Undefined Type"
                                            )
                                        })
                                    }
                                </div>
                                :
                                ""
                        }
                    </form>
                    {
                        showToast ?
                            <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center mt-3`}>
                                {toastMessage}
                            </div>
                            :
                            ""
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-sm btn-secondary w-100 rounded-pill' style={{ maxWidth: "100px" }} onClick={(e) => { setNewForm(false); }}>Close</button>
                    <button className='btn btn-sm btn-warning w-100 rounded-pill' style={{ maxWidth: "100px" }} onClick={(e) => { saveFormToDB(e); }}>Update</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default EditForm